export default __webpack_public_path__ + "static/media/logo-transparent.19e09a49.png";